import Vue from 'vue';
import initService from './init-service'
import commonService from "./common";

let headers = {
  headers: {
    'Content-Type': 'application/json',
  }
};
let expiry = initService.getExpiryData();

const diameterService = {
  // getDiameterLists() {
  //   let param = 'IOT_GetDiameterLists';
  //   return commonService.commonAPI(param)
  //     .then(response => response.data.message)
  //     .catch(error => console.error(error))
  // },

  getUpdateGraph(apiURL) {
    let url = apiURL + '&_=' + expiry;
    return Vue.axios.get(url, headers)
      .then(response => response.data.results)
      .catch(error => console.error(error))
  }
};

export  default diameterService;
